<template>

  <BasicLayout>
    <div class="elevation-4 search-box" v-if="searching">
      <v-toolbar flat="flat">
        <v-toolbar-title>Search</v-toolbar-title>
      </v-toolbar>
      <v-container fluid="fluid" grid-list-md="grid-list-md">
        <v-layout row="row" wrap="wrap">
          <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6">
            <v-text-field v-model="search.name" label="Name"></v-text-field>
          </v-flex>
          <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6">
            <v-text-field v-model="search.latitude" label="Latitude" type="number"></v-text-field>
          </v-flex>
          <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6">
            <v-text-field v-model="search.longitude" label="Longitude" type="number"></v-text-field>
          </v-flex>
          <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6">
            <v-text-field v-model="search.distance" label="Distance" type="number"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row="row" wrap="wrap">
          <v-spacer></v-spacer>
          <div class="search-error">{{ searchError }}</div>
        </v-layout>
        <v-layout row="row" wrap="wrap">
          <v-spacer></v-spacer>
          <v-btn class="search-action" color="primary" @click.native="clearSearch">Clear</v-btn>
          <v-btn class="search-action" color="primary" @click.native="loadData">Search</v-btn>
        </v-layout>
      </v-container>
    </div>
    <div class="elevation-4">
      <v-toolbar flat="flat">
        <v-toolbar-title>Places</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon class="search-bt" v-if="!searching" title="Show the search" @click="searching = true">mdi-magnify</v-icon>
        <v-icon class="search-bt" v-else title="Hide the search" @click="searching = false">mdi-magnify-close</v-icon>
        <v-dialog v-model="dialog" max-width="700px">
          <v-icon medium="medium" slot="activator">mdi-plus</v-icon>
          <v-card>
            <v-card-title class="headline">{{ dialogTitle }}</v-card-title>
            <v-card-text>
              <v-container fluid="fluid" grid-list-xl="grid-list-xl">
                <v-flex>
                  <v-text-field v-model="editedPlace.name" label="Name" placeholder="Name"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field v-model="editedPlace.latitude" label="Latitude" placeholder="Latitude"></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field v-model="editedPlace.longitude" label="Longitude" placeholder="Longitude"></v-text-field>
                </v-flex>
                <v-flex>
                  <div class="error-message">{{ errorMessage }}</div>
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat="flat" @click.native="close">Cancel</v-btn>
              <v-btn color="primary" flat="flat" @click.native="save">{{ dialogButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table :headers="columns" :items="placeResults.items" :pagination.sync="pagination" :total-items="pagination.totalItems" :loading="loading">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.latitude }}</td>
          <td>{{ props.item.longitude }}</td>
          <td class="places-actions">
            <v-icon class="mr-2" title="Edit" @click="edit(props.index)">mdi-pencil</v-icon>
            <ProxyDeleteButton @click="del(props.item)"></ProxyDeleteButton>
          </td>
        </template>
      </v-data-table>
    </div>
  </BasicLayout>

</template>

<script>

import TableView from '@/components/common/TableView'
import TableLine from '@/components/common/TableLine'
import BasicLayout from '@/layouts/BasicLayout'
import EditDeleteButtons from '@/components/common/EditDeleteButtons'
import ProxyDeleteButton from '@/components/common/ProxyDeleteButton'
import { mapState } from 'vuex'

export default {
  name: 'PlacesPage',
  components: {
    TableView,
    TableLine,
    BasicLayout,
    EditDeleteButtons,
    ProxyDeleteButton
  },
  data () {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        sortBy: null,
        descending: null
      },
      loading: false,
      dialog: null,
      editedPlace: {
        name: null,
        latitude: null,
        longitude: null
      },
      editedIndex: -1,
      errorMessage: '',
      columns: [{
        text: 'ID'
      }, {
        text: 'Name'
      }, {
        text: 'Latitude'
      }, {
        text: 'Longitude'
      }, {
        text: 'Actions',
        sortable: false
      }],
      searching: false,
      search: {
        name: null,
        latitude: null,
        longitude: null,
        distance: null
      },
      searchError: ''
    }
  },
  computed: {
    ...mapState(['placeResults']),

    dialogTitle () {
      return this.dialogButton + ' a place'
    },

    dialogButton () {
      return this.editedIndex === -1 ? 'Create' : 'Edit'
    }
  },
  watch: {
    'pagination.page' () {
      this.loadData()
    },
    'pagination.rowsPerPage' () {
      this.loadData()
    },
    'pagination.sortBy' () {
      this.loadData()
    },
    'pagination.descending' () {
      this.loadData()
    }
  },
  methods: {
    del (id) {
      this.$store.dispatch('deletePlace', id)
        .catch(console.error)
    },

    edit (index) {
      this.editedIndex = index
      this.editedPlace = JSON.parse(JSON.stringify(this.$store.state.placeResults.items[index]))
      this.dialog = true
    },

    loadData () {
      this.searchError = ''
      this.loading = true
      let sortBy = this.pagination.sortBy

      if (this.pagination.descending) {
        sortBy += ':desc'
      }

      const params = {
        page: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortBy: [sortBy]
      }

      if (params.pageSize === -1) {
        params.pageSize = 100
      }

      if (this.search.name) {
        params.name = this.search.name
      }
      if (this.search.latitude && this.search.longitude) {
        params.latitude = parseFloat(this.search.latitude)
        params.longitude = parseFloat(this.search.longitude)
      } else if (this.search.latitude || this.search.longitude) {
        this.searchError = 'You need to provide both latitude and longitude, or none of them'
        this.loading = false
        return
      }

      if (this.search.distance) {
        if (params.latitude === undefined) {
          this.searchError = 'You need to provide location to use the distance'
          this.loading = false
          return
        }
        params.maxDistanceKm = parseFloat(this.search.distance)
      }

      params.withTotalItems = true

      this.$store.dispatch('searchPlaces', params)
        .then(resp => {
          this.pagination.totalItems = resp.totalItems
          this.loading = false
        })
        .catch(err => {
          console.error('Failed to load places: ', err)
          this.loading = false
        })
    },

    close () {
      this.dialog = false
      this.editedPlace = {
        name: null,
        latitude: null,
        longitude: null
      }
      this.editedIndex = -1
      this.errorMessage = ''
    },

    save () {
      if (this.validate()) {
        return
      }

      if (this.editedIndex === -1) {
        this.createPlace()
      } else {
        this.editPlace()
      }
    },

    validate () {
      if (!this.editedPlace.name) {
        this.errorMessage = 'You must enter a valid place name'
        return true
      }

      if (this.editedPlace.latitude === '') {
        this.errorMessage = 'You must enter a latitude'
        return true
      }

      if (!this.editedPlace.longitude === '') {
        this.errorMessage = 'You must enter a longitude'
        return true
      }
      return false
    },

    createPlace () {
      this.$store.dispatch('createPlace', {
        name: this.editedPlace.name,
        latitude: parseFloat(this.editedPlace.latitude),
        longitude: parseFloat(this.editedPlace.longitude)
      }).then((resp) => {
        this.loadData()
        this.close()
      }).catch(err => {
        this.errorMessage = 'Failed to create the place'
        console.error(err)
      })
    },

    editPlace () {
      let patch = {}
      patch.name = this.editedPlace.name
      patch.latitude = parseFloat(this.editedPlace.latitude)
      patch.longitude = parseFloat(this.editedPlace.longitude)

      this.$store.dispatch('patchPlace', {
        id: this.$store.state.placeResults.items[this.editedIndex].id,
        patch: patch
      })
        .then(() => {
          this.close()
        })
        .catch(err => {
          this.errorMessage = 'Failed to edit the place'
          console.error(err)
        })
    },

    clearSearch () {
      this.search = {
        name: null,
        latitude: null,
        longitude: null,
        distance: null
      }
      this.searchError = ''
    }
  },
  mounted () {
    this.loadData()
  }
}

</script>

<style lang="scss" scoped>

@import '../styles/main-colors.scss';

.action-buttons {
  text-align: right;
}

.search-bt {
  cursor: pointer;
}

.search-box {
  margin-bottom: 30px;
}

.search-action {
  color: white;
}

.search-error {
  color: red;
}

.places-actions {
  width: 120px;
}

</style>



// WEBPACK FOOTER //
// src/pages/Places.vue